<div class="main-body leftmenu">
    <div class="page main-signin-wrapper bg-primary br-0-f">
        <router-outlet></router-outlet>
    </div>

</div>